import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {
  managerPortalRoles,
  learnerPortalRoles,
  adminPortalRoles,
} from '../../common/constants/roles';
import {useAuthStore} from '../../common/stores/authStore';
import {useOrganisationStore} from '../../common/stores/organisationStore';
import {useUserStore} from '../../common/stores/userStore';
import {type UUID} from '../../common/types/UUID';
import HomeAdminPortalCard from '../components/HomeAdminPortalCard';
import HomeLearnerPortalCard from '../components/HomeLearnerPortalCard';
import HomeManagerPortalCard from '../components/HomeManagerPortalCard';

export interface OrganisationGroupDetails {
  organisationId: UUID;
  organisationGroupsIds: UUID[];
}

export interface OrganisationDetailsInformation {
  OrganisationGroupDetails: OrganisationGroupDetails;
}

export function Home(): JSX.Element {
  const checkRoles = useAuthStore((state) => state.checkRoles);
  const organisationName = useOrganisationStore(
    (state) => state.organisationName,
  );
  const organisationGroupName = useOrganisationStore(
    (state) => state.organisationGroupName,
  );

  const name = useUserStore((state) => state.name);
  return (
    <Stack sx={{userSelect: 'none'}}>
      <Typography variant="h4">Welcome Home, {name ?? ''}!</Typography>
      {organisationName && (
        <Typography color="text.secondary" mb={2}>
          You have the <strong>{organisationName}</strong> organisation and{' '}
          <strong>{organisationGroupName}</strong> group selected.
        </Typography>
      )}
      <Stack direction="row" gap={3} px={1} flexWrap="wrap">
        {checkRoles(...learnerPortalRoles) && <HomeLearnerPortalCard />}
        {checkRoles(...managerPortalRoles) && <HomeManagerPortalCard />}
        {checkRoles(...adminPortalRoles) && <HomeAdminPortalCard />}
      </Stack>
    </Stack>
  );
}
